import { Injectable } from '@angular/core';
import { Action, Selector, State, StateContext } from '@ngxs/store';

import { ResetUserAction, StoreUserAction } from './user-state.actions';
import { User } from './user-state.model';
import { AppStoreKeys } from '../../../store/store-keys.module';

export class UserStateModel {
  readonly user: User;
  readonly isLoadedSuccessfully: boolean;
}

@State<UserStateModel>({
  name: AppStoreKeys.User,
  defaults: {
    user: {
      userId: '',
      b2cId: '',
      salesForceMasterContactId: '',
      name: '',
      givenName: '',
      lastName: '',
      email: ''
    },
    isLoadedSuccessfully: false
  }
})
@Injectable()
export class UserState {
  @Selector()
  static getUserState(state: UserStateModel): UserStateModel {
    return state;
  }

  @Selector()
  static getUser(state: UserStateModel): User {
    return state.user;
  }

  @Action(StoreUserAction)
  storeUser(context: StateContext<UserStateModel>, action: StoreUserAction): void {
    const userInfo = action?.payload;

    context.patchState({
      user: userInfo,
      isLoadedSuccessfully: action.isLoadedSuccessfully
    });
  }

  @Action(ResetUserAction)
  resetUser(context: StateContext<UserStateModel>): void {
    context.setState({
      user: {
        userId: '',
        b2cId: '',
        salesForceMasterContactId: '',
        name: '',
        givenName: '',
        lastName: '',
        email: ''
      },
      isLoadedSuccessfully: false
    });
  }
}
